import { FC } from 'react';

import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';

import { CTA_NAMES } from '@/utils/rudderstack';

import { TypeAccountERCTranslations } from '@/utils/translations/types/TypeAccountERCTranslations';

import { UpsellCard } from '../../_components/UpsellCard';

import { trackClickEvent } from '../utils';

export type LayoutNoSubscriptionProps = {
  t: TypeAccountERCTranslations;
  noSubscriptionCtaLink: string;
};

const LayoutNoSubscription: FC<LayoutNoSubscriptionProps> = ({
  t,
  noSubscriptionCtaLink,
}) => (
  <div data-testid="layout-no-subscription" className="text-center">
    <Heading
      tag={HeadingTag.H1}
      size={HeadingSize.H1}
      align="left"
      text={t.noActiveSubscription}
    />

    <UpsellCard
      headerText={t.exploreTheEarlyReaderClub}
      subText={t.exploreTheEarlyReaderClubSubtext}
      ctaText={t.exploreTheEarlyReaderClub}
      ctaLink={noSubscriptionCtaLink}
      onClick={() => {
        trackClickEvent(CTA_NAMES.EXPLORE_THE_EARLY_READER_CLUB);
      }}
    />
  </div>
);

export default LayoutNoSubscription;
